import { useCurrentWorkspace } from '../store/hooks'
import { ListCalendar } from '../components/calendar/ListCalendar'
import { SceneContainer } from '../components/scene/SceneContainer'
import { useParams } from 'react-router-dom'
import { WorkspaceNotFound } from '../components/workspace/WorkspaceNotFound'

const WorkspaceCalendarScreen = () => {
  const { workspaceId } = useParams<{ workspaceId: string }>()

  const { workspace, calendarEvents, repeatingEvents } =
    useCurrentWorkspace(workspaceId)

  if (!workspace) {
    // TODO - add a generic "create new business" cta component to use
    return <WorkspaceNotFound workspaceId={workspaceId} />
  }

  return (
    <SceneContainer title="Calendar" description="View your upcoming deadlines">
      <ListCalendar
        events={calendarEvents}
        workspaces={[workspace]}
        repeatingEvents={repeatingEvents}
        showWorkspaceLabel={false}
        showWorkspaceFilters={false}
      />
    </SceneContainer>
  )
}

export default WorkspaceCalendarScreen
